import { GET_RESOURCES } from './../constants/actionTypes'

export const getResources = data => dispatch => {
  dispatch({
    type: GET_RESOURCES,
    data
  })
}
